<template>
  <div>
    <v-card
      :disabled="loading"
      :loading="loading"
      max-width="1000"
      class="mx-auto"
    >
      <v-card-title> ตั้งค่าเจ้าหน้าที่คณะ </v-card-title>
      <v-card-text>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              เพิ่ม/แก้ไขบุคลากรที่มีสิทธิ์
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <h2>1. เลือกบุคลากร</h2>
              <v-radio-group
                row
                v-model="user_type"
                @change="selected_account_id_for_add_executor = null"
              >
                <v-radio
                  color="blue"
                  :label="'อาจารย์'"
                  :value="'teacher'"
                ></v-radio>
                <v-radio
                  color="green"
                  :label="'เจ้าหน้าที่'"
                  :value="'officer'"
                ></v-radio>
              </v-radio-group>
              <v-autocomplete
                v-model="selected_account_id_for_add_executor"
                outlined
                dense
                hide-details
                :items="filtered_accounts"
                :item-text="
                  (item) => `[${item.uid}] ${item.t_prename} ${item.t_name}`
                "
                :item-value="(item) => item.uid"
              ></v-autocomplete>

              <v-divider class="mt-5"></v-divider>

              <h2 class="mb-5 mt-5">2. มีสิทธิ์จัดการคณะ</h2>
              <SelectFaculty v-model="selected_faculty_id" />

              <h3>ระดับ</h3>
              <v-radio-group row v-model="selected_level_id">
                <v-radio
                  color="blue"
                  :label="'ปริญญาตรี'"
                  :value="'1'"
                ></v-radio>
                <v-radio
                  color="green"
                  :label="'ปริญญาโท'"
                  :value="'2'"
                ></v-radio>
                <v-radio
                  color="green"
                  :label="'ปริญญาเอก'"
                  :value="'3'"
                ></v-radio>
              </v-radio-group>

              <v-divider class="mt-3 mb-5"></v-divider>

              <h3>มีสิทธิ์</h3>
              <v-row>
                <v-col>
                  <v-checkbox
                    hide-details
                    dense
                    v-model="level_select_right"
                    :label="'มีสิทธิ์เลือกผู้ผ่านการคัดเลือก'"
                  ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    hide-details
                    dense
                    v-model="level_confirm_right"
                    :label="'มีสิทธิ์ยืนยันฉบับสมบูรณ์'"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-btn
                elevation="0"
                color="deep-orange"
                class="white--text mt-3"
                :disabled="
                  !selected_account_id_for_add_executor ||
                  !selected_faculty_id ||
                  !selected_level_id
                "
                @click="save_executor"
                >Save</v-btn
              >
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-divider class="mt-5 mb-5"></v-divider>

        <h2 class="mt-5 mb-5">รายการบุคลากรที่มีสิทธิ์</h2>

        <v-tabs v-model="level_tab">
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab v-for="(level, i) in levels" :key="i">
            <h3>{{ objectTranslator(level, "LEVEL_NAME") }}</h3>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="level_tab" touchless>
          <v-tab-item v-for="(level, i) in levels" :key="i">
            <div v-for="item in faculties" :key="item.FACULTY_ID" class="mt-5">
              <div
                v-if="
                  executor.length > 0 &&
                  executor_list_filter_by_faculty(item.FACULTY_ID, level)
                    .length > 0
                "
              >
                <h3 class="deep-orange--text">{{ item.FACULTY_NAME_TH }}</h3>
                <v-simple-table class="mb-5 mt-3" dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          #
                        </th>
                        <th
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          ลบ
                        </th>
                        <th
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          User ID
                        </th>
                        <th
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          ชื่อ-นามสกุล
                        </th>
                        <th
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          สิทธิ์ในการดูข้อมูลผู้สมัคร
                        </th>
                        <th
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          สิทธิ์ในการคัดเลือกผู้สมัคร
                        </th>
                        <th
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          สิทธิ์ในการยืนยันฉบับสมบูรณ์
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, i) in executor_list_filter_by_faculty(
                          item.FACULTY_ID,
                          level
                        )"
                        :key="item.EXECUTOR_ID"
                      >
                        <td class="text-left">{{ i + 1 }}</td>
                        <td class="text-center">
                          <v-btn
                            color="red"
                            icon
                            tile
                            @click="
                              delete_executor(
                                item.EXECUTOR_ID,
                                item.LEVEL_ID,
                                item.FACULTY_ID
                              )
                            "
                          >
                            <v-icon>mdi-trash-can</v-icon>
                          </v-btn>
                        </td>
                        <td class="text-left">
                          {{ item.uid }}
                        </td>
                        <td class="text-left">
                          {{ item.t_prename + " " + item.t_name }}
                        </td>
                        <td class="text-center">
                          <v-icon class="green--text">mdi-check-circle</v-icon>
                        </td>
                        <td class="text-center">
                          <v-icon
                            v-if="item.LEVEL_SELECT === '1'"
                            class="green--text"
                            >mdi-check-circle</v-icon
                          >
                          <v-icon
                            v-if="item.LEVEL_SELECT !== '1'"
                            class="red--text"
                            >mdi-close-circle</v-icon
                          >
                        </td>
                        <td class="text-center">
                          <v-icon
                            v-if="item.LEVEL_CONFIRM === '1'"
                            class="green--text"
                            >mdi-check-circle</v-icon
                          >
                          <v-icon
                            v-if="item.LEVEL_CONFIRM !== '1'"
                            class="red--text"
                            >mdi-close-circle</v-icon
                          >
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// import GenericProvider from "@/services/generic.provider";
import FacultyProvider from "@/services/faculty.provider";
import ConfigProvider from "@/services/config.provider";
import CentralProvider from "@/services/central.provider";
import { objectTranslator } from "@/helper/translator";
// import validator from "@/helper/validator";

// const genericService = new GenericProvider();
const configService = new ConfigProvider();
const facultyService = new FacultyProvider();
const centralService = new CentralProvider();

import SelectFaculty from "@/components/etc/SelectFaculty";
export default {
  name: "ConfigFacultyOfficerMain",

  data: () => ({
    level_tab: null,
    accounts: [],
    executor: [],
    executor_role: [],
    faculties: [],
    user_type: null,
    selected_faculty_id: null,
    selected_account_id_for_add_executor: null,
    has_faculty: false,
    selected_level_id: null,
    level_select_right: false,
    level_confirm_right: false,
  }),

  computed: {
    levels() {
      return this.$store.state.ref.levels;
    },

    filtered_accounts() {
      if (this.accounts && this.user_type) {
        return this.accounts.filter(
          (item) => item.user_type === this.user_type
        );
      }
      return [];
    },

    executor_full() {
      if (this.executor_role && this.executor && this.accounts) {
        return this.executor_role.map((role_item) => {
          const exe_item = this.executor.find(
            (exe_item) => exe_item.EXECUTOR_ID === role_item.EXECUTOR_ID
          );

          const registrar_item = this.accounts.find(
            (reg_item) => reg_item.uid == exe_item.REGISTRAR_USER_ID
          );

          return {
            ...role_item,
            ...registrar_item,
            ...exe_item,
            faculty_id_with_right: role_item.FACULTY_ID,
          };
        });
      }
      return [];
    },
  },

  components: {
    SelectFaculty,
  },

  methods: {
    objectTranslator,

    async fetch_faculty() {
      const faculties = await facultyService.getFaculties();
      this.faculties = faculties;
    },

    async fetch_account() {
      const data = await centralService.getRegistrarUserAccount();
      this.accounts = data
        .filter((item) => item.email.includes("@kmitl.ac.th"))
        .map((item) => ({
          ...item,
          uid: item.email.replace("@kmitl.ac.th", ""),
        }));
    },

    async fetch_executor() {
      this.executor = [];
      this.executor_role = [];
      const data = await configService.getExecutor();
      this.executor = data;
      const data_role = await configService.getExecutorRole();
      this.executor_role = data_role;
      this.loading = false;
    },

    async save_executor() {
      this.loading = true;
      const data = await configService
        .saveExecutor(this.selected_account_id_for_add_executor)
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
        });
      if (data.status) {
        let executor_id = 0;
        if (data.inserted_id !== 0) {
          executor_id = data.inserted_id;
        } else {
          executor_id = this.executor.find(
            (item) =>
              item.REGISTRAR_USER_ID ===
              this.selected_account_id_for_add_executor
          ).EXECUTOR_ID;
        }

        const saveRoleData = await configService
          .saveExecutorRole({
            EXECUTOR_ID: executor_id,
            LEVEL_ID: this.selected_level_id,
            FACULTY_ID: this.selected_faculty_id,
            LEVEL_SELECT: this.level_select_right,
            LEVEL_CONFIRM: this.level_confirm_right,
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
          });

        if (saveRoleData.status)
          this.$toasted.success(this.$t("toasted.create_successfully"));

        await this.fetch_executor();
      }
      this.loading = false;
    },

    async delete_executor(executor_id, level_id, faculty_id) {
      this.loading = true;
      const deleteRoleData = await configService
        .deleteExecutorRole({
          EXECUTOR_ID: executor_id,
          LEVEL_ID: level_id,
          FACULTY_ID: faculty_id,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
        });

      // const deleteData = await configService
      //   .deleteExecutor(executor_id)
      //   .catch((error) => {
      //     this.$toasted.error(JSON.stringify(error.response.data.message), {
      //       duration: 0,
      //     });
      //   });

      if (deleteRoleData.status)
        this.$toasted.success(this.$t("toasted.delete_successfully"));
      else this.$toasted.success(this.$t("toasted.cannot_delete"));

      await this.fetch_executor();
      this.loading = false;
    },

    async init() {
      this.loading = true;
      this.$store.dispatch("ref/getLevels");
      await this.fetch_faculty();
      await this.fetch_account();
      await this.fetch_executor();
      this.loading = false;
    },

    executor_list_filter_by_faculty(faculty_id, level) {
      return this.executor_full.filter(
        (item) =>
          item.faculty_id_with_right === faculty_id &&
          item.LEVEL_ID === level.LEVEL_ID
      );
    },
  },

  created() {
    this.init();
  },
};
</script>

<style scoped>
th {
  overflow: hidden;
  white-space: nowrap;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(211, 211, 211);
}
td {
  overflow: hidden;
  white-space: nowrap;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(211, 211, 211);
}
</style>
